<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import OHeader from '~/components/organisms/TheHeader.vue'
import RFooter from '~/components/organs/Footer.vue'
import RAlert from '~/components/organs/CookiesAlert.vue'
import MobilePanel from '~/components/organs/MobilePanel.vue'
import { MobilePanelPosition } from '~/static/enums/mobile-panel-position'

const { $listen, $off } = useNuxtApp()
const isPanelVisible = ref(false)
const mobilePanelRef = ref<InstanceType<typeof MobilePanel> | null>(null)

onMounted(() => {
  $listen('full-panel:open', () => {
    isPanelVisible.value = true
  })

  $listen('full-panel:closed', () => {
    isPanelVisible.value = false
    if (mobilePanelRef.value) {
      mobilePanelRef.value.collapse()
    }
  })
})

onBeforeUnmount(() => {
  $off('full-panel:open')
  $off('full-panel:closed')
})
</script>

<template>
  <div class="wrapper">
    <OHeader :is-editor="false" />
    <main>
      <slot />
    </main>
    <RFooter />
    <RAlert />

    <div
      class="global-mobile-panel"
      :class="{ 'is-active': isPanelVisible }"
    >
      <MobilePanel
        ref="mobilePanelRef"
        :selected-id="0"
        title=""
        :show-back-button="true"
        :show-close-button="false"
        :max-position="MobilePanelPosition.Max"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100dvh;
  width: 100%;
  position: relative;
  overflow-x: hidden;

  main {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;

    .btn-improvement {
      border: none;
      padding: 0;
      background: $color-grey;
      border-radius: rem(4px) rem(4px) 0 0;
      height: rem(29px);
      width: rem(142px);
      font-size: rem(14px);
      font-weight: 400;
      line-height: rem(21px);
      position: fixed;
      top: calc(50% - 57px);
      right: rem(29px);
      transform: translateY(-50%) rotate(-90deg);
      transform-origin: top right;
      transition: .3s ease;

      &:hover {
        background: $indigo;
        color: $white;
      }
    }
  }

  .global-mobile-panel {
    display: none;

    &.is-active {
      display: block;
    }
  }
}
</style>
